<!-- AddDetachedNoteForm.vue -->
<script setup>
import { ref, watch, computed, provide } from "vue";
import AddNoteForm from "./AddNoteForm.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  activityId: {
    type: Number,
    required: true,
  },
  createdByUserId: {
    type: Number,
    default: null,
  },
});

const emit = defineEmits(["close"]);

const internalHidden = ref(!props.show);

watch(
  () => props.show,
  (newVal) => {
    internalHidden.value = !newVal;
  }
);

const isModalHidden = computed({
  get() {
    return internalHidden.value;
  },
  set(val) {
    internalHidden.value = val;
    if (val === true) {
      emit("close");
    }
  },
});

// Nota avulsa → sem seleção de texto
const selectedText = ref("");
function registerMouseUpListener() {}

provide("isModalHidden", isModalHidden);
provide("selectedText", selectedText);
provide("registerMouseUpListener", registerMouseUpListener);
</script>

<template>
  <div class="detached-wrapper">
    <AddNoteForm
      :activityId="activityId"
      :createdByUserId="createdByUserId"
      :textRangeStart="0"
      :textRangeEnd="0"
      :isDetached="true"
    />
  </div>
</template>

<style scoped>
/* =====================================================================
   📏 LARGURA DO MODAL DA NOTA AVULSA
===================================================================== */
.detached-wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.detached-wrapper :deep(.modal-panel) {
  width: 50vw !important;
  max-width: 50vw !important;
}

/* =====================================================================
   ⛔ Remove a coluna direita (nota avulsa não tem trecho)
===================================================================== */
.detached-wrapper :deep(.note-col-right) {
  display: none !important;
}

/* Coluna esquerda deve virar uma coluna flex que cresce
   para permitir que o CustomTextarea ocupe a altura que sobra */
.detached-wrapper :deep(.note-col-left) {
  width: 100% !important;
  flex: 1 1 auto !important;
  padding-right: 0 !important;

  display: flex !important;
  flex-direction: column !important;
  min-height: 0; /* importante pro flex interno poder crescer/scrollar */
}

/* Mantém o container principal em flex, só que em uma coluna */
.detached-wrapper :deep(.note-two-cols) {
  display: flex !important;
  flex-direction: column !important;
  height: 100%;
  min-height: 0;
}

/* Remove o divisor da direita */
.detached-wrapper :deep(.divider-line::after) {
  display: none !important;
}

/* =====================================================================
   📝 Renomeia os textos (SEM alterar AddNoteForm.vue)
   - Cabeçalho
   - Botão principal
===================================================================== */

/* 🔹 CABEÇALHO: troca “Criar Nota” por “Criar Nota Avulsa” */
.detached-wrapper :deep(.modal-title) {
  font-size: 0; /* esconde o texto original sem remover */
}

.detached-wrapper :deep(.modal-title)::after {
  content: "Criar Nota Avulsa";
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--text-dark);
}

/* 🔹 BOTÃO: troca o texto interno “Criar Nota” */
.detached-wrapper :deep(.btn-success span) {
  font-size: 0; /* esconde o original */
}

.detached-wrapper :deep(.btn-success span)::after {
  content: "Criar Nota Avulsa";
  font-size: 0.9rem;
  font-weight: 500;
}
</style>
